import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { DataProvider } from '@services/data/base.data-provider';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { AuthService } from './services/auth.service';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  genericPages;
  facebookPages;
  otherPages;
  newsPages;
  local: string;
  pedidos: boolean;
  categories: any[];

  constructor(
    private menuCtrl: MenuController,
    private platform: Platform,
    private dataProvider: DataProvider,
    private router: Router,
    private ls: LocalStorageService,
    public auth: AuthService
  ) {
    this.initializeApp();
    this.pedidos = false;
    this.genericPages = [];
    this.loadGenerics();
    this.loadOthers();
    // this.loadLocal();
  }

  initializeApp() {
    this.platform.ready().then(() => {});
  }

  get isSideMenuDisabled() {
    return this.router.url === '/welcome' || !this.auth.authenticated;
  }

  logOut() {
    this.auth.signOut().then(() => {
      this.menuCtrl.close();
    });
  }

  // private loadCategories() {
  //   this.dataProvider.getFeaturedCategories().then(categories => {
  //     return (this.categories = categories);
  //   });
  // }
  // private loadLocal() {
  //   this.dataProvider.getBusiness().then(business => {
  //     this.local = business.storeName;
  //     const sinIndice = business.horarioEntregas;
  //     console.log(sinIndice);
  //     sinIndice.map((act, index) => {
  //       act.indice = index + 1;
  //     });
  //     // console.log(conIndice);
  //     const conIndice = sinIndice.filter(act => {
  //       return act.abierto;
  //     });

  //     this.ls.store('parametrosEntrega', conIndice);
  //     // Compruebo si tiene activa alguna forma de pedido
  //     business.pedidos.map(pedido => {
  //       if (pedido.activo) {
  //         this.pedidos = true;
  //         return;
  //       }
  //     });
  //   });
  // }

  private loadGenerics() {
    this.dataProvider.getGenerics().then(generics => {
      return (this.genericPages = generics);
    });
  }

  private loadOthers() {
    this.dataProvider.getGenericsOthers().then(others => {
      return (this.otherPages = others);
    });
  }
}
